import React, { useEffect, useState } from "react";
import Layout from "../../Components/Layout";
import "./about.css";

const About = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    setIsLoaded(true);
  }, []);

  // Function to wrap each word in a span with staggered delays
  const createRevealText = (text, startDelay = 0) => {
    return text.split(' ').map((word, index) => (
      <React.Fragment key={index}>
        <span 
          className="reveal-word"
          style={{ 
            animationDelay: `${startDelay + (index * 0.1)}s`
          }}
        >
          {word}
        </span>
        {' '}
      </React.Fragment>
    ));
  };

  // Calculate the approximate word count for previous paragraphs
  const p1 = "Bubble Computing represents a paradigm shift in distributed computational architectures, harnessing the synergistic potential of ephemeral, auto-poietic processing nodes within a non-linear, adaptive ecosystem. Our proprietary quantum-inspired topological optimization algorithms facilitate the emergence of transient computational manifolds, enabling unprecedented scalability and fault-tolerance through stochastic resonance and self-organized criticality.";
  const p2 = "By leveraging cutting-edge advances in non-equilibrium thermodynamics and information theory, Bubble Computing transcends traditional von Neumann architectures, instead embracing a holographic encoding paradigm that maximizes entropic efficiency and minimizes decoherence in high-dimensional Hilbert spaces. This revolutionary approach allows for the seamless integration of quantum superposition principles with classical bit manipulation, resulting in a hybrid computational framework that exhibits both discrete and continuous characteristics.";
  const p3 = "Our patent pending Bubble Lattice™ technology implements a hyperdimensional tensor network, capable of performing massively parallel computations through the dynamic reconfiguration of its topological structure. This self-modifying architecture leverages principles from category theory and algebraic topology to optimize information flow, resulting in exponential speedups for a wide class of NP-hard problems.";
  const p4 = "Applications of Bubble Computing span the gamut from stochastic gradient descent in non-convex loss landscapes to ab initio quantum chemistry simulations, offering unparalleled performance in domains such as high-frequency trading, protein folding, artificial intelligence, and climate modeling. By harnessing the power of quantum entanglement analogs in our classical substrate, we achieve a new frontier in computational complexity, blurring the lines between P and NP-complete problem classes.";

  // Calculate delays for each paragraph based on word count
  const p1WordCount = p1.split(' ').length;
  const p2WordCount = p2.split(' ').length;
  const p3WordCount = p3.split(' ').length;
  
  const p1Delay = p1WordCount * 0.1;
  const p2Delay = p2WordCount * 0.1;
  const p3Delay = p3WordCount * 0.1;

  return (
    <Layout>
      <main className="wrapper" style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <div className="textContainer" style={{ flexGrow: 1 }}>
          <br />
          <h2>About Bubble Computing</h2>
          {isLoaded && (
            <>
              <p>{createRevealText(p1, 0)}</p>
              <p>{createRevealText(p2, p1Delay)}</p>
              <p>{createRevealText(p3, p1Delay + p2Delay)}</p>
              <p>{createRevealText(p4, p1Delay + p2Delay + p3Delay)}</p>
            </>
          )}
        </div>
      </main>
    </Layout>
  );
};

export default About;
